import React from 'react';
import styled, { css } from 'styled-components';

const StyledLine = styled.div`
	height: 3px;
	background-color: ${props => props.theme.colors.hamburgerColor};
	border-radius: 2px;
	transition: opacity 250ms, transform 250ms;
	animation: hamDefaultState 250ms;
	transition: background-color ${({ theme }) => theme.theming.nightDayTransitionDuration};

	&:not(:last-child) {
		margin-bottom: 4px;
	}
`;

const StyledHamburger = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	width: ${props => (props.width ? props.width : '2.5rem')};
	${({ open }) => open && css`
		${StyledLine} {
			background-color: ${({ theme }) => theme.colors.black};

			&:nth-child(1) {
				transform: translate3d(0, 4px, 0) rotate(45deg);
			}

			&:nth-child(2) {
				opacity: 0;
			}

			&:nth-child(3) {
				transform: translate3d(0, -10px, 0) rotate(-45deg);
			}
		}
	`}
`;

export const Hamburger = props => (
	<StyledHamburger {...props}>
		<StyledLine />
		<StyledLine />
		<StyledLine />
	</StyledHamburger>
);
